import React, { useEffect, useState } from "react";
import styled, { useTheme } from "styled-components";
import { useTranslate } from '@tolgee/react';
import CallsList from "./CallsList";
import IconButton from "../GenericComponents/IconButton";

import { ReactComponent as NewCall } from "../../Assets/iconsv2/generic/newCall.svg";
import { useGenericComponentsStateService } from "../../Context/GenericComponentsStateContext";
import AddNewCallModal from "./AddNewCallModal";
import {
  autoUpdate,
  flip,
  offset,
  useClick,
  useDismiss,
  useFloating,
  useInteractions,
  useRole,
} from "@floating-ui/react";

const CallWrapper = ({
  calls,
  selectedCall,
  handleSelectCall,
  loadCalls,
  setLoading,
  contacts,
  handleInviteContact,
  handleCreateCallOnContactClick,
}) => {
  const { setIsAddNewCallOpen, isAddNewCallOpen } =
    useGenericComponentsStateService();
  const [searchInput, setSearchInput] = useState("");
  const theme = useTheme();

  const { refs, floatingStyles, context } = useFloating({
    open: isAddNewCallOpen,
    onOpenChange: setIsAddNewCallOpen,
    placement: "right-end",
    middleware: [offset(10), flip()], // Avoids clipping and sets offset
    whileElementsMounted: autoUpdate,
  });
  const click = useClick(context);
  const dismiss = useDismiss(context);
  const role = useRole(context);
  const { getReferenceProps, getFloatingProps } = useInteractions([
    click,
    dismiss,
    role,
  ]);

  useEffect(() => {
    loadCalls();
  }, []);
  const { t } = useTranslate();
  return (
    <Container>
      <Main>
        <Header>
          <HeaderTitle>{t('general.calls')}</HeaderTitle>
          <div ref={refs.setReference} {...getReferenceProps()}>
            <IconButton
              icon={<NewCall />}
              onClick={() => setIsAddNewCallOpen(true)}
            />{" "}
          </div>
        </Header>
        <CallsList
          searchInput={searchInput}
          setSearchInput={setSearchInput}
          calls={calls}
          selectedCall={selectedCall}
          handleSelectCall={handleSelectCall}
          loadCalls={loadCalls}
          setLoading={setLoading}
        />
      </Main>
      <Details>
        {isAddNewCallOpen && (
          <div
            ref={refs.setFloating}
            style={{
              ...floatingStyles,
              display: "flex",
              flexDirection: "column",
              width: "400px",
              zIndex: "1",
              maxHeight: "90vh", // 👈 here is the important part
            }}
          >
            <AddNewCallModal
              contacts={contacts}
              handleCreateCallOnContactClick={handleCreateCallOnContactClick}
              handleInviteContact={handleInviteContact}
            />
          </div>
        )}
        <StartCallWrapper>
          <IconButton
            onClick={() => setIsAddNewCallOpen(true)}
            style={{
              background: theme.chat.selectedBackground,
              padding: "10px",
              borderRadius: "4px",
            }}
            icon={<NewCall color={theme.menu.selectedTextColor} />}
          />
          <p>{t('call.start_a_call')}</p>
        </StartCallWrapper>
      </Details>
    </Container>
  );
};

export default CallWrapper;

const Container = styled.div`
  display: flex;
  width: 100%;
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 419px;
  width: 100%;
  background: ${({ theme }) => theme.menu.background};
  border-right: 1px solid ${({ theme }) => theme.sidebar.borderColor};
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 19px 16px;
  align-items: center;
  background: ${({ theme }) => theme.menu.background};
  border-bottom: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  gap: 20px;
`;
const HeaderTitle = styled.h3`
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.04px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
`;
const Details = styled.div`
  width: 100%;
  display: flex;
  background: ${({ theme }) => theme.menu.background};
`;
const StartCallWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
  margin: auto;
  color: ${({ theme }) => theme.menu.selectedTextColor};
`;
